module.exports = __webpack_public_path__ + "img/2192215-74-8.419d9a03.png";